/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SessionEntity
 */
export interface SessionEntity {
    /**
     * セッションID
     * @type {string}
     * @memberof SessionEntity
     */
    sessionId: string;
    /**
     * AuthユーザーID
     * @type {string}
     * @memberof SessionEntity
     */
    authUserId: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof SessionEntity
     */
    email: string;
    /**
     * アクセストークン
     * @type {string}
     * @memberof SessionEntity
     */
    accessToken?: string;
    /**
     * ユーザー情報
     * @type {object}
     * @memberof SessionEntity
     */
    userInfo?: object;
}

/**
 * Check if a given object implements the SessionEntity interface.
 */
export function instanceOfSessionEntity(value: object): value is SessionEntity {
    if (!('sessionId' in value) || value['sessionId'] === undefined) return false;
    if (!('authUserId' in value) || value['authUserId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function SessionEntityFromJSON(json: any): SessionEntity {
    return SessionEntityFromJSONTyped(json, false);
}

export function SessionEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'],
        'authUserId': json['authUserId'],
        'email': json['email'],
        'accessToken': json['accessToken'] == null ? undefined : json['accessToken'],
        'userInfo': json['userInfo'] == null ? undefined : json['userInfo'],
    };
}

export function SessionEntityToJSON(json: any): SessionEntity {
    return SessionEntityToJSONTyped(json, false);
}

export function SessionEntityToJSONTyped(value?: SessionEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionId': value['sessionId'],
        'authUserId': value['authUserId'],
        'email': value['email'],
        'accessToken': value['accessToken'],
        'userInfo': value['userInfo'],
    };
}

